import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface FAQItem {
  question: string;
  answer: string;
}

interface FAQProps {
  items: FAQItem[];
}

export function FAQ({ items }: FAQProps) {
  const [expandedItem, setExpandedItem] = useState<number | null>(null);

  const toggleItem = (index: number) => {
    setExpandedItem(prev => prev === index ? null : index);
  };

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="w-full max-w-4xl mx-auto text-center">
      <div className="space-y-4">
        {items.map((item, index) => {
          const isExpanded = expandedItem === index;
          
          return (
            <Card key={index} className="overflow-hidden">
              <button
                onClick={() => toggleItem(index)}
                className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
              >
                <span className="font-semibold text-lg pr-4">{item.question}</span>
                {isExpanded ? (
                  <ChevronDown className="h-5 w-5 flex-shrink-0 text-gray-500" />
                ) : (
                  <ChevronRight className="h-5 w-5 flex-shrink-0 text-gray-500" />
                )}
              </button>
              
              {isExpanded && (
                <CardContent className="px-6 pb-6 pt-0">
                  <div className="prose dark:prose-invert max-w-none">
                    <div dangerouslySetInnerHTML={{ __html: item.answer }} />
                  </div>
                </CardContent>
              )}
            </Card>
          );
        })}
      </div>
    </div>
  );
}